import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { createOnboardingActionsSlice, createOnboardingDataSlice } from './slices'
import type { OnboardingStore } from './types'

export const useOnboardingStore = create<OnboardingStore>()(
  devtools(
    subscribeWithSelector(
      immer((...args) => ({
        ...createOnboardingDataSlice(...args),
        ...createOnboardingActionsSlice(...args),
      }))
    ),
    {
      name: 'OnboardingStore',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
